import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  AfterViewInit,
  Output,
  ViewChild,
} from '@angular/core';
import { environment } from '../../../environments/environment';

declare global {
  interface Window {
    turnstile: any;
  }
}

@Component({
  selector: 'app-turnstile',
  standalone: true,
  template: `<div #turnstileContainer></div>`,
})
export class TurnstileComponent implements AfterViewInit, OnDestroy {
  @Input() siteKey = environment.cloudflareSkey;
  @Input() theme: 'light' | 'dark' | 'auto' = 'auto';
  @Output() verified = new EventEmitter<string>();
  @Output() expired = new EventEmitter<void>();
  @Output() errored = new EventEmitter<void>();

  @ViewChild('turnstileContainer', { static: true }) container!: ElementRef<HTMLDivElement>;

  private widgetId: string | null = null;

  constructor(private ngZone: NgZone) {}

  ngAfterViewInit(): void {
    this.waitForTurnstile();
  }

  private waitForTurnstile(): void {
    if (window.turnstile) {
      this.renderWidget();
    } else {
      setTimeout(() => this.waitForTurnstile(), 100);
    }
  }

  private renderWidget(): void {
    this.ngZone.runOutsideAngular(() => {
      this.widgetId = window.turnstile.render(this.container.nativeElement, {
        sitekey: this.siteKey,
        theme: this.theme,
        callback: (token: string) => {
          this.ngZone.run(() => this.verified.emit(token));
        },
        'expired-callback': () => {
          this.ngZone.run(() => this.expired.emit());
        },
        'error-callback': () => {
          this.ngZone.run(() => this.errored.emit());
        },
      });
    });
  }

  reset(): void {
    if (this.widgetId !== null && window.turnstile) {
      window.turnstile.reset(this.widgetId);
    }
  }

  ngOnDestroy(): void {
    if (this.widgetId !== null && window.turnstile) {
      window.turnstile.remove(this.widgetId);
    }
  }
}